<template>
  <button
    type="button"
    :class="['button-link', { 'is-loading': loading, 'is-disabled': disabled }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <span class="button-text"><slot></slot></span>
  </button>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', event)
      }
    },
  },
}
</script>

<style scoped>
.button-text{
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
}
.button-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width:100%;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid transparent;
  color:#282E3E;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

}

.button-link:hover:not(.is-disabled) {
  background-color: #E6E6E6;
}

.button-link:active:not(.is-disabled) {
  @apply bg-base-40;
}

.button-link:focus:not(.is-disabled) {
  border: 1px solid #89BEFA;
  outline: none;

}

.button-link.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f3f4f6;
}

</style>
